var map = {
	"./automotive-light.webp": "173d",
	"./cpos-light.webp": "375d",
	"./emsps-light.webp": "20e5",
	"./ev-drivers-light.webp": "8077",
	"./government-research-light.webp": "f69b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86c4";